import { get } from "react-hook-form";
import { getInventoryList } from "../modules/StoresModule/Services/InventoryConfigurationService";
import { updatePartRequestDetailPart } from "../modules/StoresModule/Services/partRequestService";
import { getTermsAndCondition } from "../modules/SupplyChainModules/Services/PartRequestManagementService";
import { createRFQ } from "../modules/SupplyChainModules/Services/QuoteService";

// const baseUrl = "https://dev01.aspsols.com:8991";

const baseUrl =
  import.meta.env.MODE === "staging"
    ? "https://kodo-develop.aspsols.com"
    : "https://kodo-develop.aspsols.com";

// const baseUrl =
//   import.meta.env.MODE === "staging"
//     ? "https://kodo-develop.aspsols.com"
//     : `${window.location.origin}`;

// const baseUrl =
//   import.meta.env.MODE === "staging"
//     ? "https://terminus-staging.aspsols.com"
//     : "https://terminus-develop.aspsols.com";

export const environment = {
  production: import.meta.env.MODE === "development" ? false : true,

  basePath: "/secure", //this is the base path for redirections in the routes of the app , start all redirections with this property example :  const basePath = environment.basePath;  navigate(basePath + "/dashboard")

  // data for config of microsoft authentication library
  msalConfig: {
    auth: {
      clientId:
        import.meta.env.MODE === "development"
          ? "2f43b990-5bb0-4db8-a48f-6e0433f0c6f2"
          : import.meta.env.MODE === "staging"
          ? "1f1b4aea-f436-4755-812a-4aacc82b7859"
          : "eff1cb8e-f575-48a6-a0bf-f4cc7af81bf8",
      tenantId: "organizations",
    },

    graphConf: {
      graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    },

    scopes: {
      scope: ["User.Read"],
    },

    refreshTokenEndpoind:
      "https://login.microsoftonline.com/organizations/oauth2/v2.0/token",
  },

  // amchart5 License
  amchartLicense: "AM5C-6014-4693-0568-0936",

  ElemensPerPage: 20, // this is the quantity of element to get per page in every list paginated in the app
  debounceTime: 300, // use this for debounce time in search or something like that
  snackbarsDisappearanceTime: 3000,
  emailRegexPattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // this is the regex pattern for email validation

  // http endpoints bellow
  socketsConnectionURL: "https://kodo-develop.aspsols.com/ws",
  getActiveModulesMenu: baseUrl + "/api/get-modules", // menu modules

  // use to get userProfile info
  getUserInfo: baseUrl + "/api/get-user-info",
  getAnchoredResourceByUser: baseUrl + "/api/get-anchored-resources-by-user",
  getPermissions: baseUrl + "/api/get-resource-actions",
  saveAnchoredResource: baseUrl + "/api/save-anchored-resource-by-user",
  updateInfoCompanies: baseUrl + "/api/update-selected-company",
  updateHistoryNavigation: baseUrl + "/api/register-navigation",
  getRecentNavigation: baseUrl + "/api/get-recent-navigation",
  saveRecentSearch: baseUrl + "/api/search/save-search",
  getRecentSearch: baseUrl + "/api/search/get-recent-search",
  getGlobalSearchResults: baseUrl + "/api/search/global-search",
  getGlobalSearchFiles: baseUrl + "/api/search/manual-search-files",
  // use to get dropDownData and configuration
  getDropDownConfig: baseUrl + "/dev/get-dropdown?",
  getDropdownData: baseUrl + "/dev/get-dropdown-data?",

  //engineering dialog
  getCategorySections: baseUrl + "/api/get-engineering-sections",

  //part configuration
  getParts: baseUrl + "/api/get-parts",
  createPart: baseUrl + "/api/save-part",
  deletePart: baseUrl + "/api/delete-part",

  //part configuration - Supply chain
  saveSiteRepairs: baseUrl + "/api/save-site-repair-types",
  deleteSiteRepairs: baseUrl + "/api/delete-site-repair-types",
  getPartRepairSites: baseUrl + "/api/get-part-sites-repair-types",
  getSiteRepairs: baseUrl + "/api/get-site-repair-types",
  getPartVendors: baseUrl + "/api/get-part-vendors",
  getPartVendorsCosts: baseUrl + "/api/get-part-vendors-costs",
  getPartVendorCondition: baseUrl + "/api/get-part-vendor-condition",
  getPartVendorRepair: baseUrl + "/api/get-part-vendor-repair-type",
  saveTATInfo: baseUrl + "/api/save-part-vendor",
  saveVendorCost: baseUrl + "/api/save-part-vendor-cost",
  getSpecificCost: baseUrl + "/api/get-part-vendor-cost",
  deleteTatInfo: baseUrl + "/api/delete-part-vendor",
  deleteCostRange: baseUrl + "/api/delete-part-vendor-unit-cost",

  // effectivity
  getPartEff: baseUrl + "/api/get-part-effectiveness",
  savePartEff: baseUrl + "/api/save-part-effectivity",
  savePartEffSelection: baseUrl + "/api/save-part-effectivity-selecction",
  savePartEffRange: baseUrl + "/api/save-part-effectivity-range",
  deletePartEff: baseUrl + "/api/delete-part-effectivity",
  deletePartEffSelection: baseUrl + "/api/delete-part-effectivity-selecction",
  deletePartEffectivityRange: baseUrl + "/api/delete-part-effectivity-range",
  getEffSelection: baseUrl + "/api/get-part-effectivity-selecctions",
  getEffRanges: baseUrl + "/api/get-part-effectivity-ranges",

  //part configuration - Finance
  getFinanceInfo: baseUrl + "/api/get-average-finance-info-by-part",
  getGlAccountsInfo: baseUrl + "/api/get-gl-accounts-by-part",
  saveGlPartInfo: baseUrl + "/api/save-gl-accounts-by-part",

  //part configuration - stores
  getStoresInfo: baseUrl + "/api/get-store-by-part",
  saveStoreInfo: baseUrl + "/api/save-store-by-part",

  //configuration>parts>engineering>interchangeability
  createInterchangeability: baseUrl + "/api/save-interchangeability",
  getInterchangeabilities: baseUrl + "/api/get-interchangeability",
  deleteInterchangeability: baseUrl + "/api/delete-interchangeability",
  simulateInterchangeability: baseUrl + "/api/simulate-interchangeability",
  getTargetInterchangeabilities:
    baseUrl + "/api/get-interchangeabilities-to-part",
  // createInterchangeability: "http://localhost:3000" + "/api/save-interchangeability",

  //engineeringTask
  getEngTasks: baseUrl + "/api/get-engineering-tasks",
  getEtItem: baseUrl + "/api/get-engineering-task",
  getSchedule: baseUrl + "/api/get-engineering-task-general-schedule",

  //configuration>parts>engineering>timecontrols
  getTimeControls: baseUrl + "/api/get-time-controls",
  saveTimeControl: baseUrl + "/api/save-et-control",
  getTimeControl: baseUrl + "/api/get-time-control",
  deleteTimeControl: baseUrl + "/api/delete-et-control",
  getSpecificOverrides: baseUrl + "/api/get-time-control-overrides",
  saveOverride: baseUrl + "/api/save-et-control-part",
  deleteOverride: baseUrl + "/api/delete-et-control-part",
  getOverride: baseUrl + "/api/get-time-control-override",

  //nla
  savePositions: baseUrl + "/api/save-nla-positions",
  deletePositions: baseUrl + "/api/delete-nla-positions",

  //kits
  getKits: baseUrl + "/api/get-kits",
  saveKit: baseUrl + "/api/save-kit-part",
  deleteKit: baseUrl + "/api/delete-kit-part",

  // getPartConfigurationInfo: "http://localhost:3000/part-configuration-info"
  getPartConfigurationInfo: baseUrl + "/api/get-part",
  getDropdownEntity: baseUrl + "/dev/get-dropdown-entity",

  // store module
  getStoreModuleMenuResources: baseUrl + "/api/get-resources?",
  moduleOptions: baseUrl + "/api/get-resources",

  // locations configuration
  getLocations: baseUrl + "/api/get-locations?", // return the list of the locations actives
  getLocation: baseUrl + "/api/get-location?", // return the info of one location specifically
  saveLocation: baseUrl + "/api/save-location", //useTo create a new Location
  updateLocation: baseUrl + "/api/save-location", //used to update the information in the location
  deleteLocation: baseUrl + "/api/delete-location?", // use to delete a location

  getSites: baseUrl + "/api/get-sites?", // use to getSites in sites config modal on the locations component
  createSite: baseUrl + "/api/save-site", // useTo CREATE and UPDATE a site
  getSite: baseUrl + "/api/get-site?",
  deleteSite: baseUrl + "/api/delete-site?",
  saveAircraftCompatibility: baseUrl + "/api/save-aircraft-compability",
  deleteAircraftCompatibility: baseUrl + "/api/delete--aircraft-compability?",

  createRack: baseUrl + "/api/save-rack",
  updateRack: baseUrl + "/api/save-rack",
  deleteRack: baseUrl + "/api/delete-rack?",
  getRacks: baseUrl + "/api/get-racks?", //use to get a list of racks
  getRack: baseUrl + "/api/get-rack?", // use to get the info about one specific rack
  // shelves
  createShelf: baseUrl + "/api/save-shelve",
  updateShelf: baseUrl + "/api/save-shelve",
  deleteShelf: baseUrl + "/api/delete-shelve?",
  getShelves: baseUrl + "/api/get-shelves?", //use to get a list of shelves
  getShelf: baseUrl + "/api/get-shelve?", // use to get the info about one specific shelf}

  // bins
  createBin: baseUrl + "/api/save-bin",
  updateBin: baseUrl + "/api/save-bin",
  deleteBin: baseUrl + "/api/delete-bin?",
  getBins: baseUrl + "/api/get-bins?", //use to get a list of bins
  getBin: baseUrl + "/api/get-bin?", // use to get the info about one specific bin

  // aircraft
  getTypeSeries: baseUrl + "/api/get-types-series",
  getTypeSeriesConfigurationInfo: baseUrl + "/api/get-type-series",
  calculateActualAircaftsByType: baseUrl + "/api/get-aircraft-counts",
  createType: baseUrl + "/api/save-type-series",
  deleteType: baseUrl + "/api/delete-type-series",
  getAircraftList: baseUrl + "/api/get-aircraft-list",
  getAircrafConfigurationInfo: baseUrl + "/api/get-aircraft-info",
  createAircraft: baseUrl + "/api/save-aircraft",
  deleteAircraft: baseUrl + "/api/delete-aircraft",
  getBalanceByAircraft: baseUrl + "/api/get-aircraft-balance",
  getWarrantyAircraft: baseUrl + "/api/get-aircraft-warranty",
  updateWarranty: baseUrl + "/api/save-warranty-aircraft",
  updateBalance: baseUrl + "/api/save-balance-aircraft",
  updateDeliveryInformation:
    baseUrl + "/api/save-delivery-information-aircraft",
  getDeliveryInformationAircraft:
    baseUrl + "/api/get-aircraft-delivery-information",
  getLastFlightInformation:
    baseUrl + "/api/get-aircraft-last-flight-information",

  // inventoryManagement
  getInventoryList: baseUrl + "/api/get-inventory-list",
  getPartTransacctionHistory: baseUrl + "/api/get-inventory-transaction-info",
  getTimeControlsByPart: baseUrl + "/api/get-time-control-by-serilaized-part",
  getPartLocationHistory: baseUrl + "/api/get-inventory-location-info",
  getPartPositionInformation: baseUrl + "/api/get-inventory-position-info",
  getInventoryAdditionalPartInfo: baseUrl + "/api/get-additional-part-info",
  getPartRequestInfoByPart: baseUrl + "/api/get-part-request-info-by-part",
  getTaskCardsFindingsByPart: baseUrl + "/api/get-task-cards-findings-list",
  getInventoryTransactionsIssues:
    baseUrl + "/api/get-inventory-transaction-issues",

  //part request
  getPartRequestList: baseUrl + "/api/get-part-request-list",
  createPartRequest: baseUrl + "/api/save-part-request",
  savePartRequest: baseUrl + "/api/save-part-request?",
  getPartRequestTabularInfo: baseUrl + "/api/get-part-request-tabular-details",
  issuePartsFromPartRequest: baseUrl + "/api/issue-from-part-request",
  partReturn: baseUrl + "/api/part-return",
  deletePartRequest: baseUrl + "/api/delete-part-request?",
  getPRNListDetails: baseUrl + "/api/get-part-request-list-details?",
  getPRNEditionForm: baseUrl + "/api/get-part-request-form?",
  getEmployeesByLocation: baseUrl + "/api/get-employees-by-location?",
  getSerializedPartsToPRNparts:
    baseUrl + "/api/get-available-serialized-parts?",
  getBatchToPRNParts: baseUrl + "/api/get-available-batch-parts?",
  deletePartRequestDetailPart:
    baseUrl + "/api/delete-part-request-detail-part?",
  updatePartRequestDetailPart: baseUrl + "/api/save-part-request-detail-part?",
  createPartRequestAndIssue: baseUrl + "/api/save-part-request-issue",

  //part request supply chain
  getPartRequestSupplyChainList: baseUrl + "/api/get-supply-chain-part-request",
  getPartRequestSupplyChainListTransfer:
    baseUrl + "/api/get-supply-chain-part-request-transfer",
  companyStockByPart: baseUrl + "/api/get-company-stock-by-part",
  createTransferPartRequest: baseUrl + "/api/save-transfer-part-request",
  createMultipleTransferPR: baseUrl + "/api/save-multiple-part-request",
  getVendorInfo: baseUrl + "/api/get-vendor-info",
  getTermsAndCondition: baseUrl + "/api/get-terms-and-conditions-by-company",
  createNewOrder: baseUrl + "/api/new-order",
  createNewMultipleOrder: baseUrl + "/api/new-multiple-order",
  createRFQ: baseUrl + "/api/create-rfq",
  getQuoteList: baseUrl + "/api/get-quote-list",
  getPrnQuoteList: baseUrl + "/api/get-prn-quote-list",
  getPrnQuoteModalList: baseUrl + "/api/get-prn-quote-modal-list",
  getVendorQuoteList: baseUrl + "/api/get-vendor-quote-list",
  getVendorQuoteModalList: baseUrl + "/api/get-vendor-quote-modal-list",
  getVendorQuoteDetailInfo: baseUrl + "/api/get-quote-deatil-info",
  updateFromQuote: baseUrl + "/api/update-details-rfq",

  // orders management
  getOrdersList: baseUrl + "/api/get-order-list?",
  getOrdersListDetails: baseUrl + "/api/get-order-list-detail?",
  getOrderGeneralTimeLineData: baseUrl + "/api/get-order-header-time-line?",
  getOrderGeneralInformation: baseUrl + "/api/get-order-info-form?",
  getOrderDetailInformation: baseUrl + "/api/get-order-detail-info-form?",
  updateOrdersGeneralInfo: baseUrl + "/api/update-order-header",
  updateOrderDetails: baseUrl + "/api/update-order-detail",
  authorizeOrder: baseUrl + "/api/authorize-order",
  getApprovalRange: baseUrl + "/api/get-approval-range-by-user",
  sentOrderToVendor: baseUrl + "/api/sent-to-vendor",

  // receiving
  getOrdersReceivingList: baseUrl + "/api/get-order-list-receiving?",
  receiveOrder: baseUrl + "/api/vendor-order-receive",
  saveDiscrepancy: baseUrl + "/api/save-vendor-order-discrepancy",
  getNLAHierarchy: baseUrl + "/api/get-nla-part-hierarchy?",
  getActuals: baseUrl + "/api/get-actuals-parts-flights?",
  getReceivingET: baseUrl + "/api/get-part-et?",
  savePartInitialActuals: baseUrl + "/api/save-initial-actuals-parts-flight",
  saveSerializedPartInReceiving: baseUrl + "/api/save-serialized-part",

  //package intake
  getAwbInfo: baseUrl + "/api/get-awb-numbers-info",
  getOrders: baseUrl + "/api/get-awb-number-orders",
  saveBox: baseUrl + "/api/save-awb-number-box",
  getAwbObj: baseUrl + "/api/get-awb-numbers-info",
  saveAwbObj: baseUrl + "/api/save-awb-number",
  // saveAwbObj: "http://localhost:3200/save-awb-number",

  getBoxes: baseUrl + "/api/get-awb-number-boxes",
  getImage: baseUrl + "/api/download-file",

  //vendor approval
  getVendorOrders: baseUrl + "/api/get-vendor-orders",
  getOrderDetails: baseUrl + "/api/get-vendor-order-details",
  approveOrder: baseUrl + "/api/approve-order",
  rejectOrder: baseUrl + "/api/reject-order",
  saveOrderInfo: baseUrl + "/api/save-awb-order-information",
  getOrderInfo: baseUrl + "/api/get-awb-order-information",
  // saveOrderInfo: "http://localhost:3200/save-awb-order-information",
  // approveOrder: "http://localhost:3000" + "/api/approve-order",
  // rejectOrder: "http://localhost:3000" + "/api/reject-order",

  //vendor discrepancies
  getVendorDiscrepancies: baseUrl + "/api/get-vendor-discrepancies",

  //file download
  downloadFile: baseUrl + "/api/download-file",

  // quote entry
  getQuotes: baseUrl + "/api/get-vendor-portal-quotes?",
  getQuotesDetails: baseUrl + "/api/get-vendor-portal-quotes-details?",
  updateRFQ: baseUrl + "/api/update-details-rfq",
  emitQuoteEntry: baseUrl + "/api/emit-vendor-quotes",

  //dashboard services
  getDashboardByWorkstream: baseUrl + "/api/get-dashboard-by-workstream?",
  getPanelsByTabId: baseUrl + "/api/get-panels-by-tabId?",
  createNewTabInWorkstream: baseUrl + "/api/add-dashboard-tab",
  createPanelDashboard: baseUrl + "/api/add-dashboard-panel",
  updatePanelDashboardPosition:
    baseUrl + "/api/update-dashboard-panel-position",
  deleteDashboardPanel: baseUrl + "/api/delete-dashboard-panel",
  deleteDashboardTab: baseUrl + "/api/delete-dashboard-tab",

  //dashboard configuration panel
  getPredifinedPanelCategories: baseUrl + "/api/folders/by-account?",
  getPredifinedPanelSubcategoriesByCategoryId:
    baseUrl + "/api/folders/subfolders?",
  getPredifinedPanelsByFilter: baseUrl + "api/folders/panels",
  setPredifinedPanelCategorySelectState:
    baseUrl + "/api/folders/selected-folder?",
  setPredifinedPanelCategoryUnSelectState:
    baseUrl + "/api/folders/selected-folder?",
  getPredifinedPanels: baseUrl + "/api/folders/panels?",
  getTableConfigurationByPanelId:
    baseUrl + "/api/datasource/table-configuration?",
  getConsumeDataByPanelId: baseUrl + "/api/datasource/consume-data?",
  getPieConfigurationByPanelId: baseUrl + "/api/datasource/pie-configuration?",
  getXyChartConfigurationByPanelId:
    baseUrl + "/api/datasource/xy-configuration?",
  // discrepancy management
  getDiscrepancy: baseUrl + "/api/get-vendor-order-discrepancies?",
  getDiscrepancyMessages: "/api/get-messages?",
  getKpiConfigurationByPanelId: baseUrl + "/api/datasource/kpi-configuration?",
  sendDiscrepancyMessage: baseUrl + "/api/sendMessage",
  getPanelSizeRestrictions: baseUrl + "/api/get-panel-size-restrictions?",

  //dashboard tab configuration
  updateTabInWorkstream: baseUrl + "/api/edit-dashboard-tab",

  // Filters dashboard tab
  getPanelControlCenter: baseUrl + "/api/filters/get-control-center?",
  getFiltersByControlCenter:
    baseUrl + "/api/filters/get-filters-by-control-center-group?",
  getConsumeDataByFilterId: baseUrl + "/api/datasource/dropdown/consume-data?",
  saveControlFilters: baseUrl + "/api/filters/save-control-center-filters",
  getSaveControlFilters: baseUrl + "/api/filters/get-control-center-filters?",
};
